/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
//import receiveResourceConnects from './receive-resource-connects';

export default (resourceConnectId) => (dispatch) => {
    //dispatch({
    //    type: actions.RESOURCE_CONNECTS,
    //});

    if (!resourceConnectId) {
        throw 'no id provided';
    }

    return cecSdk
        .resourceConnect(resourceConnectId)
        .get()
        .then((resourceConnect) => {
            //dispatch({
            //    type: actions.RESOURCES_REQUEST_SUCCESS,
            //});
            //dispatch(receiveResourceConnects([resourceConnect]));
            return resourceConnect;
        });
};
